// extracted by mini-css-extract-plugin
export default {"wrapper":"empty-list__wrapper___x0jfY","title":"empty-list__title___fCZXd","subtitle":"empty-list__subtitle___ohehV","scalable":"empty-list__scalable___ShLRy"};